package team.platforma.dictionary_domain.use_case.ai_chapter

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.transform
import team.platforma.dictionary_data.repository.AiChapterRepository
import team.platforma.dictionary_domain.model.AiChapterDomain

class AiChapterTableUseCase(
    private val repository: AiChapterRepository
) {
    fun observe(): Flow<List<AiChapterDomain>> = repository.getAllPlayers().transform { value ->
        val list = value.map { AiChapterDomain(it.id, it.name) }
        return@transform emit(list)
    }
}